"use client";

import * as React from "react";
import { addDays, format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { DateRange } from "react-day-picker";

import {
  cn,
  dateForFirstOfMonthAndYesterdayDate,
} from "../../../helpers";
import { Button } from "../../ui/button";
import { Calendar } from "../../ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../ui/popover";

interface DateRangesProps {
  setDate: (val: any) => void;

  date: DateRange | undefined;
}

const DateRangeForInvoice = ({ setDate, date }: DateRangesProps) => {
  return (
    <div className={cn("grid gap-2")}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn(
              "w-[250px] justify-start text-left font-normal border border-border_primaryDarkBlue text-text_primaryDarkBlue text-sm font-Roboto",
              !date && "text-text_primaryDarkBlue text-sm font-Roboto"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} -{" "}
                  {format(date.to, "LLL dd, y")}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={setDate}
            numberOfMonths={2}
            toDate={new Date()}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
export default DateRangeForInvoice;
